// extracted by mini-css-extract-plugin
export default {"btnRestric":"ProductBuildPageV2TableRow_btnRestric__8u0IN","btnRoyalty":"ProductBuildPageV2TableRow_btnRoyalty__j4neb"};